import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { TasksSidePanel } from 'modules/project_management/components/TaskSidePanel'

const TaskDetail = () => {
  const { id, taskId } = useParams()
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const [openSidePanel, setopenSidePanel] = React.useState<boolean>(true)

  const closeTaskSidePanel = () => {
    setopenSidePanel(false)
    if (id) {
      navigate(navigation.projects.id.details.tasks.fullPath({ id }))
    } else {
      navigate(navigation.projects.fullPath())
    }
  }

  return (
    <TasksSidePanel
      projectId={Number(id)}
      taskId={Number(taskId)}
      open={openSidePanel}
      onClose={closeTaskSidePanel}
    />
  )
}

export default TaskDetail
